import { CompetitionHistory } from "@hireroo/app-store/widget/e/CompetitionHistory";
import type { Widget } from "@hireroo/presentation";

import CompetitionHistoryListFetchContainer from "../CompetitionHistoryList/FetchContainer";
export type GenerateCompetitionHistoryPropsArgs = {
  candidateId: string;
};

export const useGenerateProps = (args: GenerateCompetitionHistoryPropsArgs): Widget.CompetitionHistoryProps => {
  const initializedFilter = CompetitionHistory.useInitializedFilter();
  const filter = CompetitionHistory.useFilter();

  return {
    searchForm: {
      disabled: !initializedFilter,
      defaultValues: {
        textFilter: filter.textFilter,
      },
      onChange: fields => {
        CompetitionHistory.updateFilter(fields);
      },
    },
    List: <CompetitionHistoryListFetchContainer candidateId={args.candidateId} />,
  };
};
